import React from 'react'
import styled from 'styled-components'
import { Icon } from '../icons/Icon'
import { Label } from '../layout'

interface PullToRefreshIndicatorProps {
  label: string
    visible: boolean
    isRefreshing: boolean
    onClick: () => void
}

const IndicatorContainer = styled.div<{ visible: boolean; isRefreshing: boolean }>`
  position: fixed;
  bottom: 100px;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    bottom: 70px;
  }
  left: 50%;
  transform: translateX(-50%) ${props => props.visible ? 'scale(0.8)' : 'scale(0.6)'};
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  background-color: rgba(26, 32, 44, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  padding: 10px 24px;
  
  color: white;
  
  opacity: ${props => props.visible ? 1 : 0};
  pointer-events: ${props => props.visible ? 'auto' : 'none'};
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1;
    opacity: ${props => props.visible ? 1 : 0};
    transition: opacity 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:active {
    transform: translateX(-50%) scale(0.65);
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

const IconWrapper = styled.div<{ isRefreshing: boolean }>`
  display: flex;
  ${props => props.isRefreshing && `
    animation: spin 1s linear infinite;
  `}
`
export const RefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
    visible,
    isRefreshing,
    onClick,
    label,
}) => {
    const [effectiveRefreshing, setEffectiveRefreshing] = React.useState(isRefreshing)
    const startTimeRef = React.useRef(0)

    React.useEffect(() => {
        if (isRefreshing) {
            startTimeRef.current = Date.now()
            setEffectiveRefreshing(true)
        } else {
            const elapsed = Date.now() - startTimeRef.current
            const remaining = 1000 - elapsed
            const timeout = remaining > 0 ? remaining : 0

            const timer = setTimeout(() => {
                setEffectiveRefreshing(false)
            }, timeout)
            return () => clearTimeout(timer)
        }
    }, [isRefreshing])

    const show = visible || effectiveRefreshing

    return (
        <IndicatorContainer onClick={onClick} visible={show} isRefreshing={effectiveRefreshing}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px" }}>
                <IconWrapper isRefreshing={effectiveRefreshing}>
                    <Icon icon="refresh" size="medium" color="white" />
                </IconWrapper>
                <Label style={{ marginTop: 0, color: 'white', letterSpacing: '0.5px', fontSize: '14px' }}>{label}</Label>
            </div>
        </IndicatorContainer>
    )
}
